
module.exports = function(bootstrap) {
    bootstrap.directive('generateGraphs', ["modal", "navigation", "brand", "services", "session", "$state", "$cookies", "coremetrics", "teamsite", "$document", "$timeout", function(modal, navigation, brand, services, session, $state, $cookies, coremetrics, teamsite, $document, $timeout) {
        return {
            replace: false,
            template: require('directives/hmhs/generate-graphs.html'),
            scope: {
                generateGraphs: '=',
                graphTitle: '=',
                graphData: '=',
                graphColors: '='
            },
            link: function(scope, element) {
                //bar graph
                var generateBarGraph = function(graph){
                    var bindingId = '#' + scope.graphTitle +  scope.generateGraphs;
                    var chart = c3.generate({
                        bindto: bindingId,
                        padding:{
                            bottom:10
                        },
                        data: {
                            columns: [
                                graph.data1,
                                graph.data2
                            ],
                            type: 'bar',
                            names:{
                                data1: graph.data1Title,
                                data2: graph.data2Title
                            },
                            colors:{
                                data2: scope.graphColors.data1,
                                data1: scope.graphColors.data2
                            }
                        },
                        bar:{
                            width:{
                                radio:0.75
                            }
                        },
                        legend:{
                            inset: {
                                anchor: 'top-right',
                                x: 20,
                                y: 10,
                                step: 2
                            }
                        },
                        axis:{
                            x:{
                                type:'category',
                                categories:graph.axis
                            }
                        }
                    });

                };

                var generateLineGraph = function(graph){
                    var bindingId = '#' + scope.graphTitle +  scope.generateGraphs;
                    var chart = c3.generate({
                        bindto: bindingId,
                        padding:{
                            bottom:15
                        },
                        data: {
                            columns: [
                                graph.data1,
                                graph.data2
                            ],
                            names:{
                                data1: graph.data1Title,
                                data2: graph.data2Title

                            },
                            colors:{
                                data1: scope.graphColors.data1,
                                data2: scope.graphColors.data2
                            },
                            regions: {
                                'data1': [{'start':0, 'style':'dashed'}]
                            }
                        },
                        axis:{
                            x:{
                                type:'category',
                                categories:graph.axis
                            },
                            y:{
                                tick:{
                                    format: d3.format("s")
                                }
                            }
                        },
                        color: function (color, d) {
                            // d will be 'id' when called for legends
                            return d.id && d.id === 'data1' ? d3.rgb(color).darker(d.value / 150) : color;
                        }
                    });

                };

                var generateSingleLineGraph = function(graph){
                    var bindingId = '#' + scope.graphTitle +  scope.generateGraphs;
                    var chart = c3.generate({
                        bindto: bindingId,
                        padding:{
                            bottom:15
                        },
                        data: {
                            columns: [
                                graph.data1
                            ],
                            names:{
                                data1: graph.data1Title

                            },
                            colors:{
                                data1: scope.graphColors.data1
                            },
                            regions: {
                                'data1': [{'start':0, 'style':'dashed'}]
                            }
                        },
                        axis:{
                            x:{
                                type:'category',
                                categories:graph.axis
                            },
                            y:{
                                tick:{
                                    format: d3.format("s")
                                }
                            }
                        },
                        color: function (color, d) {
                            // d will be 'id' when called for legends
                            return d.id && d.id === 'data1' ? d3.rgb(color).darker(d.value / 150) : color;
                        }
                    });

                };

                var generateDonutGraph = function(graph){
                    var percentageCurrentYear, secondPercentageCurrentYear, percentagePreviousYear, secondPercentageTwoPreviousYear;
                    //data 2 = current year
                    //data 1 = previous year
                    percentageCurrentYear = graph.data2.pop();
                    var arrayFirst = percentageCurrentYear;
                    percentageCurrentYear = percentageCurrentYear / 100;

                    secondPercentageCurrentYear = graph.data2.pop();
                    graph.data2.push(secondPercentageCurrentYear);
                    graph.data2.push(arrayFirst);
                    secondPercentageCurrentYear = secondPercentageCurrentYear / 100;

                    graph.percentageChangeCurrentYear = ((percentageCurrentYear - secondPercentageCurrentYear) * 100).toFixed(2);
                    if(percentageCurrentYear > secondPercentageCurrentYear){
                        graph.percentUpDownCurrentYear = 'Up';
                    }else if(percentageCurrentYear < secondPercentageCurrentYear){
                        graph.percentUpDownCurrentYear = 'Down';
                    }
                    graph.percentageChangeCurrentYear = Math.abs(graph.percentageChangeCurrentYear) + '%';


                        c3chart = window.c3.generate({
                        size:{
                            height: 200,
                            width: 150
                        },
                        bindto: '#' + scope.graphTitle +  scope.generateGraphs + 'B',
                        legend: {
                            show: false
                        },
                        // data on load is hardcoded;
                        // this way, when we get the real data via the load method, the values will animate in;
                        data: {
                            columns:[
                                ['show', percentageCurrentYear],
                                ['noShow', 1-percentageCurrentYear]
                            ],
                            type: "donut"
                        },
                        color:{
                            pattern:[scope.graphColors.data1, scope.graphColors.data2]
                        },
                        // set the animation length;
                        transition: {
                            duration: 0
                        },
                        donut: {
                            // hide the "in-donut" label since we have our own layered on top of this chart;
                            label: {
                                show: false
                            },
                            title: Math.round(percentageCurrentYear * 100) + '%',
                            // stop the mouseover grow effect;
                            expand: false,
                            // set the width of the donut ring;
                            width: 15
                        },
                        // hide the mouseover;
                        tooltip: {
                            show: false
                        },
                        interaction: {
                            enabled: false
                        }
                    });

                    if(graph.data1.length > 1){
                        percentagePreviousYear = graph.data1.pop();
                        percentagePreviousYear = percentagePreviousYear / 100;

                        //Check in place for first month of the year
                        if(graph.data1.length > 1){
                            secondPercentagePreviousYear = graph.data1.pop();
                            secondPercentagePreviousYear = secondPercentagePreviousYear / 100;

                            graph.percentageChangePreviousYear = ((percentagePreviousYear - secondPercentagePreviousYear) * 100).toFixed(2);


                            if(percentagePreviousYear > secondPercentagePreviousYear){
                                graph.percentUpDownPreviousYear = 'Up';
                            }else if(percentagePreviousYear < secondPercentagePreviousYear){
                                graph.percentUpDownPreviousYear = 'Down';
                            }
                            graph.percentageChangePreviousYear = Math.abs(graph.percentageChangePreviousYear) + '%';
                        }else{
                            graph.percentageChangePreviousYear = '';

                        }



                        c3chart = window.c3.generate({
                            size:{
                                height: 200,
                                width: 150
                            },
                            bindto: '#' + scope.graphTitle +  scope.generateGraphs,
                            legend: {
                                show: false
                            },
                            // data on load is hardcoded;
                            // this way, when we get the real data via the load method, the values will animate in;
                            data: {
                                columns:[
                                    ['show', percentagePreviousYear],
                                    ['noShow', 1-percentagePreviousYear]
                                ],
                                type: "donut"
                            },
                            color:{
                                pattern:[scope.graphColors.data1, scope.graphColors.data2]
                            },
                            // set the animation length;
                            transition: {
                                duration: 0
                            },
                            donut: {
                                // hide the "in-donut" label since we have our own layered on top of this chart;
                                label: {
                                    show: false
                                },
                                title: Math.round(percentagePreviousYear * 100) + '%',
                                // stop the mouseover grow effect;
                                expand: false,
                                // set the width of the donut ring;
                                width: 15
                            },
                            // hide the mouseover;
                            tooltip: {
                                show: false
                            },
                            interaction: {
                                enabled: false
                            }
                        });
                    }else{
                        //erases all traces of graph if not available
                        graph.percentUpDownPreviousYear = '';
                        graph.percentageChangePreviousYear = '';
                        graph.data1Title = '';
                        graph.singleDonut = true;
                    }
                };

                var graph = scope.graphData;
                if(scope.graphData.data1.length > 0 && scope.graphData.data1[0] != 'data1'){
                    scope.graphData.data1.splice(0,0,'data1');
                }
                if(scope.graphData.data2 && scope.graphData.data2.length > 0 && scope.graphData.data2[0] != 'data2'){
                    scope.graphData.data2.splice(0,0,'data2');
                }


                $timeout(function(){
                    scope.$apply();
                    if(!graph.type){
                        graph.type = 'Line';
                    }
                    if(graph.type == 'Bar'){
                        generateBarGraph(graph);
                    }else if(graph.type == 'Line'){
                        if(scope.graphData.data2){
                            generateLineGraph(graph);
                        }else{
                            generateSingleLineGraph(graph);
                        }

                    }else if(graph.type == 'Donut'){
                        generateDonutGraph(graph);
                    }
                })



            }
        }
    }])
};